<template>
  <template v-if="isAdmin">
    <div>
      <!-- TAB PROJECT SETTINGS -->
      <premium-section v-if="manageTabIndex == 'config-projectsettings'" feature="business-config">
        <manage-config-project-settings style="max-width: 700px"></manage-config-project-settings>
      </premium-section>
      <!-- TAB FEATURES -->
      <premium-section v-if="manageTabIndex == 'config-integrations'" feature="business-config">
        <manage-config-integrations style="max-width: 700px"></manage-config-integrations>
      </premium-section>
      <!-- TAB TOOLS -->
      <keep-alive>
        <premium-section v-if="manageTabIndex == 'config-tools'" feature="business-tools">
          <div class="pb-6" style="position: relative; max-width: 700px">
            <manage-config-tools-replace-users></manage-config-tools-replace-users>
            <div class="pt-6"></div>
            <manage-config-tools-split-planning></manage-config-tools-split-planning>
          </div>
        </premium-section>
      </keep-alive>
    </div>
    <!-- TAB AUTOMATIONS -->
    <premium-section v-if="manageTabIndex == 'config-automations'" feature="automations">
      <manage-config-automations></manage-config-automations>
    </premium-section>
  </template>
  <v-card v-else class="pa-6 d-inline-flex align-center">
    <v-icon size="large" class="mr-2">far fa-lock</v-icon>{{ $t('PREMIUM.ONLY_FOR_ADMIN') }}
  </v-card>
</template>

<script>
  import { defineAsyncComponent } from 'vue';
  import ManageConfigProjectSettings from './ManageConfigProjectSettings.vue';
  import ManageConfigIntegrations from './ManageConfigIntegrations.vue';
  import ManageConfigToolsReplaceUsers from './ManageConfigToolsReplaceUsers.vue';
  import ManageConfigToolsSplitPlanning from './ManageConfigToolsSplitPlanning.vue';
  import useUsersAccessRightStore from '@/stores/users/accessRight';
  import useManageStore from '@/stores/manage';

  export default {
    components: {
      ManageConfigProjectSettings,
      ManageConfigIntegrations,
      ManageConfigToolsReplaceUsers,
      ManageConfigToolsSplitPlanning,
      ManageConfigAutomations: defineAsyncComponent(() => import('./ManageConfigAutomations.vue')),
    },
    data() {
      return {
        usersAccessRightStore: useUsersAccessRightStore(),
        manageStore: useManageStore(),
      };
    },
    computed: {
      manageTabIndex: {
        get() {
          return this.manageStore.manageTabIndex;
        },
        set(newVal) {
          this.manageStore.manageTabIndex = newVal;
        },
      },
      isAdmin() { return this.usersAccessRightStore.isAdmin; },
    },
  };
</script>
